// @flow
import * as React from 'react';
import ButtonIndex from 'components/ButtonIndex';
import {
  LocalizedParagraph,
  useLocalized,
} from 'components/Localized';
import Logo from 'components/Logo';
import GuideMessageContainer from 'components/GuideMessageContainer';
import GuideMessageCenter from 'components/GuideMessageCenter';
import * as VideoUtils from 'utils/videoUtils';
import Disclaimer from 'components/Disclaimer';
import ButtonNextPage from 'components/ButtonNextPage';
import SoundToggleButton from 'components/SoundToggleButton';

type Props = {
  onOpenModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
  onSkip: () => void,
};

export default function ChargingStationA(props: Props): React.Element<any> {
  const localized = useLocalized();
  const [page, setPage] = React.useState(0);
  //const [videoPlayed, setVideoPlayed] = React.useState(false);
  console.log("ChargingStationA page:", page);
  const handleNextPage = React.useCallback(() => {
    if (page === 0) {
      VideoUtils.loadB01_1();
      VideoUtils.play();
      VideoUtils.onEnd(()=>{
        //setVideoPlayed(true);
      });
      window.tagManager.chargingStationCompleteChargingLinkClick();
      setPage(page + 1);
    }
    else if (page === 1) {
      //setPage(page + 1);
      props.onNext();
    }
    
  }, [page, props]);

  React.useEffect(()=>{
    VideoUtils.loadB01_1();
  }, []);
  React.useEffect(()=>{
    if (page === 0) {
      window.tagManager.drivingZoneCourseBChargingStationCompleteChargingPage();
    }
  },[page]);

  return (
    <main>
      <GuideMessageContainer onClick={handleNextPage}>
        <GuideMessageCenter show={page === 0}>
          <LocalizedParagraph {...localized.driving_b02_charging_001} />
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 1}>
          <LocalizedParagraph {...localized.driving_b02_charging_002} />
        </GuideMessageCenter>
      </GuideMessageContainer>
      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />


      {page === 0 && <ButtonNextPage buttons={[{onNext: props.onSkip, title:localized.driving_b00_index_guide_005, dataBackground:"#05141f", dataOutline:"#ffffff", widthD:199, widthM:124}, {onNext: handleNextPage, title: localized.button_next}]} />}
      {page === 1 && <ButtonNextPage buttons={[{onNext: handleNextPage, title: localized.button_next}]} />}

      <Logo />
      <SoundToggleButton />
      <Disclaimer textKey="disclaimer_default" />
      
    </main>
  );
}
